import React from 'react';
import { FormattedMessage, IntlShape } from 'react-intl';
import { Modal } from '@superops/ui-design-system';
import { getTranslatedText } from '@nile/components';

export interface PolicyOverrideWarningModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  intl: IntlShape;
}

export function PolicyOverrideWarningModal({
  open,
  onConfirm,
  onCancel,
  loading = false,
  intl
}: PolicyOverrideWarningModalProps) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={getTranslatedText(intl, 'common.override.policy.title')}
      variant="confirmation"
      iconSize="xl"
      primaryAction={{
        content: getTranslatedText(intl, 'common.save'),
        onAction: onConfirm,
        loading: loading,
        disabled: loading
      }}
      secondaryActions={[
        {
          content: getTranslatedText(intl, 'common.discard.changes'),
          onAction: onCancel,
          disabled: loading
        }
      ]}
    >
      <div className="pt-5">
        <FormattedMessage id="common.override.policy.message" />
      </div>
    </Modal>
  );
}

export default PolicyOverrideWarningModal;
